const STORAGE_KEY = 'auth_device_id';
const FALLBACK_VALUE = 'aiia-device-fallback';

const safeLocalStorage = {
  get(key) {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.warn('Unable to read from localStorage:', error);
      return null;
    }
  },
  set(key, value) {
    if (typeof window === 'undefined' || !window.localStorage) return;
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.warn('Unable to write to localStorage:', error);
    }
  },
  remove(key) {
    if (typeof window === 'undefined' || !window.localStorage) return;
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn('Unable to remove localStorage key:', error);
    }
  }
};

const normalizeFingerprint = (value) => {
  if (!value) {
    return null;
  }
  return value.replace(/[^a-z0-9-]/gi, '').slice(0, 64) || null;
};

const generateFingerprint = () => {
  const base =
    (typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID()) ||
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return normalizeFingerprint(base) || FALLBACK_VALUE;
};

export const getDeviceFingerprint = () => {
  if (typeof window === 'undefined') {
    return FALLBACK_VALUE;
  }

  let fingerprint = safeLocalStorage.get(STORAGE_KEY);
  if (!fingerprint) {
    fingerprint = generateFingerprint();
    safeLocalStorage.set(STORAGE_KEY, fingerprint);
  }
  return fingerprint || FALLBACK_VALUE;
};

export const clearDeviceFingerprint = () => safeLocalStorage.remove(STORAGE_KEY);

export default getDeviceFingerprint;
